import React, { useEffect, useState, useRef, useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import { Form } from 'reactstrap'
import BillGeneratModal from '../../../../components/Modal/BillGeneratModal';
import SelectTable from '../../../../components/SelectTable';
import axios from 'axios';
import { loaderAction } from '../../../../redux/actions/Index';
import { environment } from '../../../../env';
import { useDispatch, useSelector } from 'react-redux';
import PriceFormater from '../../../../Helper/PriceFormater';
import moment from 'moment';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import PathName from '../../../../components/PathName/PathName';

const Billing = (props) => {
    const [rentpay, setRentpay] = useState([])
    const [filterdata, setFilterdata] = useState(undefined)
    const [filterBuilding, setFilterBuilding] = useState([]);
    const [projectLists, setProjectLists] = useState([]);
    const [dateDisable, setDateDisable] = useState(moment().format('YYYY-MM'));
    const [billdata, setBilldata] = useState([])
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const [extraRender, setExtraRender] = useState(true);
    const [filteredInvoice, setFilteredInvoice] = useState([]);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const SendFrom = useSelector((state) => state?.ModalReducer?.sendFrom);



    const dispatch = useDispatch();
    const {
        register,
        watch,
        reset,
        control,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();

    var selectedProject = watch('project');
    var selectedBuilding = watch('building');
    var billing_type = watch('billing_type');
    var selectedInvestor = watch('investor');
    var selectedTenant = watch('tenant');
    var selectedmonth = watch('month');
    var sendfrom = watch('send_from')
    var search = watch('search')


    const BuildingOptions = async (query) => {
        let filteredBuildings;
        const filteredBuildingURL = `${environment.baseUrl}filter-building/`;
        const FilterBuildingPayload = new FormData();
        FilterBuildingPayload.append('query', query);

        const result = await axios.post(filteredBuildingURL, FilterBuildingPayload).then((response) => {
            let filteredBuilding = [];
            let tempArrayFilterWithProject = [];
            response.data.map((BuildingList) => {
                if(userProject == BuildingList?.project){
                    filteredBuilding.push({ label: BuildingList.building_no, value: BuildingList.id })
                }
            })
            tempArrayFilterWithProject = filteredBuilding?.sort((a, b) =>
                                                a?.building_no?.localeCompare(b.building_no))
            filteredBuildings = tempArrayFilterWithProject;
        })

        if (filteredBuildings.length > 0) {
            return filteredBuildings
        } else {
            return []
        }
    };

    useMemo(() => {
        if(userProject){
            let filterBuildingDefaultList = [];
            buildingList?.map(item => {
                if(item?.project?.id == userProject){
                    filterBuildingDefaultList.push({ label: item.building_no, value: Number(item.id) })
                }
            })
            filterBuildingDefaultList = filterBuildingDefaultList?.sort((a, b) =>
                                                a?.building_no?.localeCompare(b.building_no))
            setFilterBuilding(filterBuildingDefaultList)
        }
    }, [userProject, buildingList])

    useMemo(() => {
        let buildinglisttt = [];
        buildingList?.filter((filterBuilding) => { if (filterBuilding?.id == selectedBuilding?.value) { buildinglisttt.push(filterBuilding) } })
    }, [selectedBuilding?.value])

    const ProjectOptions = async (query) => {
        let filteredProjects;
        const filteredProjectURL = `${environment.baseUrl}filter-project/`;
        const FilterProjectPayload = new FormData();
        FilterProjectPayload.append('query', query);
        const result = await axios.post(filteredProjectURL, FilterProjectPayload).then((response) => {
            let filteredProject = [];
            response.data.map((projectList) => {
                filteredProject.push({ label: projectList.name, value: projectList.id })
            })
            filteredProjects = filteredProject;
        })
        if (filteredProjects.length > 0) {
            return filteredProjects
        } else {
            return []
        }
    };
    useMemo(() => {
        let cc = [];

        if (projectList) {
            projectList.map((project) => {
                cc.push({ label: project.name, value: project.id })
            })
        }
        setProjectLists(cc)
    }, [projectList]);

    const getRentAnnual = async () => {
        dispatch(loaderAction(true))
        try {
            await axios.get(`${environment.baseUrl}rentannual`).then((rent) => {
                dispatch(loaderAction(false))
                getProposalInvestors(rent.data);
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }
    }
    const getAllRentPayment = async () => {
        dispatch(loaderAction(true))
        const billpayload = new FormData();
        billpayload.append('project', '')
        billpayload.append('building', '')
        billpayload.append('month', '')
        try {
            await axios.post(`${environment.baseUrl}all-rentpay`, billpayload).then((rent) => {
                if(rent.data.code != undefined && rent.data.code==400){
                    setRentpay([]);
                }else{
                    let tempRent = [];
                    rent?.data.map(item => {
                        if(item?.gala_investor?.proposal?.project?.id == userProject){
                            tempRent.push(item)
                        }
                    })
                    setRentpay(tempRent);
                }
                dispatch(loaderAction(false))
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }
    }

    const filterRent = async (project, building, month) => {
        dispatch(loaderAction(true))
        const billpayload = new FormData();
        billpayload.append('project', project == undefined? (userProject != undefined? userProject: "" ): project)
        billpayload.append('building', building == undefined ? (selectedBuilding != undefined ? selectedBuilding?.value : "") : building)
        billpayload.append('month', month)
        try {
            await axios.post(`${environment.baseUrl}all-rentpay`, billpayload).then((rent) => {
                if(rent.data.code != undefined && rent.data.code==400){
                    setRentpay([]);
                }else{
                    let tempRent = [];
                    console.log(rent.data);
                    rent?.data.map(item => {
                        if(item?.gala_investor?.proposal?.project?.id == userProject){
                            tempRent.push(item)
                        }
                    })
                    setRentpay(tempRent);
                    console.log(tempRent);
                }
                dispatch(loaderAction(false))
                filterLogic()
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }
    }

    const getProposalInvestors = async (rent) => {
        dispatch(loaderAction(true))
        try {
            await axios.get(`${environment.baseUrl}proposal-investors/`).then((proposal) => {
                let d = proposal.data;
                d.map((item) => {
                    item.rent = rent?.filter((data) => data.proposal?.id == item.proposal?.id)
                })
                let projectFilerArray = [];
                d?.map(item => {
                    if(item.investor.project.id == userProject){
                        projectFilerArray.push(item)
                    }
                })
                setBilldata(projectFilerArray)
                dispatch(loaderAction(false))
                filterLogic()
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }
    }

    const filterLogic = (bill_type_field = "") => {
        if(billing_type == undefined){
            bill_type_field = "rent"
        }else{
            bill_type_field = billing_type
        }

        let filteredData = [];
        billdata?.map(item =>{
            let flag = false;
            const selected_date = new Date(`${selectedmonth}-01`)
            const start_date = new Date(item?.rent[0]?.start_date)
            if(selectedBuilding != undefined && (item.investor.building.id != selectedBuilding.value)){
                flag = true;
            }
            if (!flag && search != undefined && !(item.investor.Investors.name.toLowerCase().includes(search))){
                flag = true;
            }
            if (!flag && (start_date.getMonth() <= selected_date.getMonth()) && (start_date.getFullYear() <= selected_date.getFullYear())){
                rentpay?.map(rentData => {
                    if(rentData.gala_investor.id == item.id && rentData.bill_type == bill_type_field){
                        const rent_date = new Date(rentData.rent_date)
                        const selected_date = new Date(`${selectedmonth}-01`)
                        if((rent_date.getMonth() === selected_date.getMonth()) && (rent_date.getFullYear() === selected_date.getFullYear()) ){
                            flag = true;
                        }
                    }
                })
            }else{
                flag = true;
            }
            if(!flag){
                setExtraRender(false);
                filteredData.push(item);
            }
        })
        setFilteredInvoice(filteredData);
        if(filteredData.length > 0){
            setExtraRender(false);
            setTimeout(()=>{
                // Wait for 100ms
                setExtraRender(true);
            },100)
        }
    }

    useMemo(()=>{
        filterLogic()
    },[billing_type,selectedmonth,selectedBuilding,billdata,search,rentpay])

    const columns = [
        {
            name: 'Investor',
            selector: row => row?.investor?.Investors.name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Tenant',
            selector: row => row?.proposal?.name_of_company,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Building',
            selector: row => row.investor?.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Gala',
            selector: row => row.investor?.gala?.gala_no + " " + "Gala",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.required_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Rent Sq.Ft',
            selector: row => <PriceFormater price={row?.rent[0]?.rent} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Amount',
            selector: row => <PriceFormater price={row.required_area * row?.rent[0]?.rent} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'GST',
            selector: row => <PriceFormater price={parseInt((row.required_area * row?.rent[0]?.rent) * (0.09))} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Bill Amount',
            selector: row => <PriceFormater price={(row.required_area * row?.rent[0]?.rent) + (row.required_area * row?.rent[0]?.rent) * (0.09)} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        // {
        //     name: 'Action',
        //     selector: row => <BillGeneratModal details={row} />,
        //     sortable: true,
        //     style: {
        //         fontSize: "2.6rem",
        //     }
        // },
    ];

    useEffect(() => {
        if(userProject != undefined){
            getRentAnnual();
            getAllRentPayment();
            reset({ 'month': moment().format('YYYY-MM') })
        }
    }, [userProject])
    const monthDis = (e) => {
        if ((moment(e.target.value).format('YYYY-MM')) > moment().format('YYYY-MM')) {
            setDateDisable((moment().format('YYYY-MM')))
        } else {
            setDateDisable(moment().format('YYYY-MM'));
        }
    }
    useMemo(() => {
        if (selectedProject && selectedBuilding && selectedmonth) {
            filterRent(selectedProject?.value, selectedBuilding?.value, moment(selectedmonth).format("YYYY-MM-01"))
        }

    }, [selectedmonth, selectedBuilding, selectedProject])

    const Clear = () => {
        reset({
            "project": "",
            "building": "",
            "tenant": "",
            "investor": "",
        });

    }

    useEffect(()=>{
        if(billing_type == "rent" && sendfrom != ""){
            setValue('send_from',"");
        }
        setExtraRender(false);
        setTimeout(()=>{
            // Wait for 100ms
            setExtraRender(true);
        },100)
    },[billing_type,sendfrom,selectedmonth])

    return (
        <>
            <PathName />
            <div className="Building-main">
                <Form >
                    <div className='my-4 row'>
                        <div className={'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'}>
                            <input className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                type='search'
                                autoComplete='off'
                                placeholder='Search Party Name...'
                                {...register('search')}
                            /> 
                            <br />
                        </div>
                        <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                            <div className='w-100'>
                                <select
                                    id="billing_type"
                                    name="billing_type"
                                    defaultValue="rent"
                                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 py-4 modal-input"
                                    {...register("billing_type")}
                                >
                                    {/* <option value="">Select Billing Type</option> */}
                                    <option value="rent">Rent</option>
                                    <option value="maintenance">Maintenance</option>
                                    <option value="varai">Varai</option>
                                    <option value="extra_amenities">Extra Amenities </option>
                                    <option value="other_charges">Other charges </option>
                                    {/* <option value="electricitybill">Electricity bill</option> */}
                                </select>
                            </div>
                            <br />
                        </div>
                        {
                            billing_type !== 'rent' && billing_type !== '' && <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                                <div className='w-100'>
                                    <select
                                        id="send_from"
                                        name="send_from"
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 py-4 modal-input"
                                        {...register("send_from")}
                                    >
                                            <option value="">Select Send From</option>
                                        {SendFrom?.map(item => (<option value={item.id}>{item.name}</option>))}
                                    </select>
                                </div>
                                <br />
                            </div>
                        }

                        <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                            <div className='w-100'>
                                <Controller
                                    control={control}
                                    name="building"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange },
                                        fieldState: { isTouched, isDirty, error },
                                        formState,
                                    }) => (
                                        <AsyncSelect placeholder="Search Building" cacheOptions defaultOptions={filterBuilding} loadOptions={BuildingOptions} className='w-100' onChange={onChange} />
                                    )}
                                />
                            </div>
                            <br />
                        </div>
                        <div className={billing_type !== 'rent' && billing_type !== '' ? 'col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1' : 'col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'}>
                            <div className='w-100'>
                                <input
                                    className='p-3 shadow-none   w-100  title-font-500 fs-2  border-radius-10 modal-input '
                                    type='month'
                                    max={dateDisable}
                                    autoComplete='off'
                                    {...register("month", { onChange: (e) => { monthDis(e) } })}
                                />
                            </div>
                            <br />
                        </div>
                        {/* <div className='col-11 mx-auto mx-md-0 col-md-1 col-lg-1 col-xl-1 pb-3 '>
                            <button type="button" onClick={Clear} className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary"><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Clear</span></button>
                        </div> */}
                    </div>
                </Form>
                <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                    {
                        extraRender && (filterdata ? <>
                            {filterdata.length == 0 ? <EmptyTable /> :
                                <SelectTable columns={columns} data={filterdata} rentpay={rentpay} allFormData={getValues()} handelAllRent={filterRent} selectedProject={selectedProject?.value} selectedBuilding={selectedBuilding?.value} selectedmonth={moment(selectedmonth).format('YYYY-MM-01')}/>}
                        </>
                            :
                            <>
                                {filteredInvoice.length != 0 ? <SelectTable columns={columns} data={filteredInvoice} rentpay={rentpay} allFormData={getValues()} handelAllRent={filterRent} selectedProject={selectedProject?.value} selectedBuilding={selectedBuilding?.value} selectedmonth={moment(selectedmonth).format('YYYY-MM-01')}/> : <EmptyTable />}
                            </>)
                    }
                </div>
            </div>
        </>
    )
}

export default Billing